import LoadingComponent from "../../app/layout/LoadingComponent";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import axios from "axios";
import React, { useEffect, useState } from "react";

import Container from "react-bootstrap/Container";
import { Button } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { Image } from "semantic-ui-react";

import Footer from "../Footer";

import "../PerfilInstitucional/src/pInstitucional.css";

import cardSolicitud from "../PerfilInstitucional/src/img/solicitud.png";
import cardConvenio from "../PerfilInstitucional/src/img/convenios.png";
import cardReportes from "../PerfilInstitucional/src/img/reportes.png";
import { RegionalBannerCentral } from "../Portafolio/Handlers/RegionalBannerCentral";
import { myBreadCrumbsConvRaiz } from './Handlers/BreadCrumbsConv';

var activeC: string = "Gestión de Códigos Institucionales"

function EntradaAdministrador() {
  return (
    <>
      <Container className="content-institu entradas-panels">
        
        <div className="title-area-institu">
            <h2>Gestión de Códigos Institucionales</h2>
        </div>

        <div className="bread-institu">
          {myBreadCrumbsConvRaiz(activeC)}
        </div>
        
        <Row>

          <Col className="block-institu block-l">
            <Link to={"/home/operaciones/:id/CrearSolicitud"} >
              <Image src={cardSolicitud} />
              <h2>Crear solicitud</h2>
              <p>
                Centro de solicitudes.<br></br> En este apartado podrás revisar
                tus solicitudes creadas previamente y crear nuevas solicitudes
                pára generar códigos institucionales.
              </p>
              <span>VER MAS</span>
            </Link>
          </Col>

          <Col className="block-institu block-l">
            <Link to={"/home/operaciones/:id/SolicitudesCreadas"} >
              <Image src={cardSolicitud} />
              <h2>Solicitudes creadas</h2>
              <p>
                Centro de solicitudes.<br></br> En este apartado podrás revisar
                tus solicitudes creadas previamente y crear nuevas solicitudes
                pára generar códigos institucionales.
              </p>
              <span>VER MAS</span>
            </Link>
          </Col>

          <Col className="block-institu block-m">
            <Link to={"/home/operaciones/:id/CrearConvenio"}>
              <Image src={cardConvenio} />
              <h2>Crear código</h2>
              <p>
                Centro de Códigos Institucionales.<br></br> En este apartado podrás adjuntar la
                documentación requerida pára cáda uno de tus códigos
                solicitados.
              </p>
              <span>VER MAS</span>
            </Link>
          </Col>

        </Row>


        <Row className="second-cards-block">
          <Col className="block-institu block-r">
            <Link to={"/home/operaciones/:id/ConveniosCreados"}>
              <Image src={cardReportes} />
              <h2>Códigos creados</h2>
              <p>
                Centro de reportes.<br></br> En este apartado podrás obtener un
                listado de los estudiantes beneficiados con tus códigos.
              </p>
              <span>VER MAS</span>
            </Link>
          </Col>

          <Col className="block-institu block-l">
            <Image src={cardSolicitud} />
            <h2>Cotizaciones</h2>
            <p>
              Centro de solicitudes.<br></br> En este apartado podrás revisar
              tus solicitudes creadas previamente y crear nuevas solicitudes
              pára generar códigos.
            </p>
            <span>VER MAS</span>
          </Col>

          <Col className="block-institu block-m">
            <Image src={cardReportes} />
            <h2>Reportes</h2>
            <p>
              Centro de reportes.<br></br> En este apartado podrás obtener un
              listado de los estudiantes beneficiados con tus códigos.
            </p>
            <span>VER MAS</span>
          </Col>

        </Row>


      </Container>
    </>
  );
}

export default EntradaAdministrador;
